const boundaryRotate = 50

export const stopRotate = (rotate: number) => {
  if (Math.abs(rotate) > boundaryRotate) {
    return Math.sign(rotate) * boundaryRotate
  }

  return rotate
}
